import {
  deleteBudgetAddReductionApply,
  getBudgetAddReductionInfo,
  getBudgetAddReductionList,
  saveBudgetAddReductionApply,
} from '../services';

export default {
  namespace: 'budgetAddReduction',
  state: {},
  effects: {
    // 预算追加追减列表
    *getBudgetAddReductionList({ payload }, { call }) {
      return yield call(getBudgetAddReductionList, payload);
    },

    // 保存预算追加追减申请单
    *saveBudgetAddReductionApply({ payload }, { call }) {
      return yield call(saveBudgetAddReductionApply, payload);
    },

    // 查询预算追加追减申请单详情
    *getBudgetAddReductionInfo({ payload }, { call }) {
      return yield call(getBudgetAddReductionInfo, payload);
    },

    // 删除预算追加追减申请单
    *deleteBudgetAddReductionApply({ payload }, { call }) {
      return yield call(deleteBudgetAddReductionApply, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
